export interface Testimonial {
  id: number;
  name: string;
  rating: number;
  text: string;
  source: string;
  avatar: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Petr Hanzlík',
    rating: 5,
    source: 'Google',
    avatar: 'https://topratedhomepros.com/website/sites-images/testimony-150x150-google.png',
    text: 'I recently used One Call Handyman Service for some repairs around my house, and I couldn\'t be happier with the results. The team was courteous, knowledgeable, and completed the job in a timely manner. Their attention to detail and commitment to customer satisfaction sets them apart. I\'ll definitely be calling them again.',
  },
  {
    id: 2,
    name: 'Liam Fleming',
    rating: 5,
    source: 'Google',
    avatar: 'https://topratedhomepros.com/website/sites-images/testimony-150x150-google.png',
    text: 'One Call Handyman Service exceeded my expectations. They were able to fix a variety of issues around my house, including some tricky electrical problems. The technicians were professional and clearly knew what they were doing. I\'m very satisfied with their work and will call them again for any future needs.',
  },
  {
    id: 3,
    name: 'Nicholas Jackson',
    rating: 5,
    source: 'Google',
    avatar: 'https://topratedhomepros.com/website/sites-images/testimony-150x150-google.png',
    text: 'One Call Handyman Service is outstanding! They arrived promptly, fixed everything perfectly, and were incredibly professional. Highly recommend for any home improvement or repair work in the Houston area.',
  },
  {
    id: 4,
    name: 'Louis Cook',
    rating: 5,
    source: 'Google',
    avatar: 'https://topratedhomepros.com/website/sites-images/testimony-150x150-google.png',
    text: 'Exceptional service from One Call Handyman! They were efficient, friendly, and their work quality was top-notch. Will definitely use them again for future Houston home improvement projects!',
  },
  {
    id: 5,
    name: 'Ericka Gutierrez',
    rating: 5,
    source: 'Google',
    avatar: 'https://topratedhomepros.com/website/sites-images/testimony-150x150-google.png',
    text: 'I would like to thank the staff of One Call Handyman Services for bringing life back into my home. Very detailed and clean. The project was completed before schedule with no surprises. Owner Anjela Sanchez is always available to answer questions and communicated with me daily. I will most definitely use them again.',
  },
  {
    id: 6,
    name: 'Angelica Perez',
    rating: 5,
    source: 'Google',
    avatar: 'https://topratedhomepros.com/website/sites-images/testimony-150x150-google.png',
    text: 'I had the best service with One Call Handyman! I had my tile installed beautifully! They were quick and affordable. I highly recommend! I will definitely be calling them again when I need more work done.',
  },
  {
    id: 7,
    name: 'Larry DeBondt',
    rating: 5,
    source: 'Google',
    avatar: 'https://topratedhomepros.com/website/sites-images/testimony-150x150-google.png',
    text: 'Made initial contact and within hours Richard had completed the job. Needed to have mailbox and rotten wooden post replaced. Had it replaced with a new metal post and mailbox. Would gladly use their services on any future jobs.',
  },
  {
    id: 8,
    name: 'Omayra Montalvo',
    rating: 5,
    source: 'Google',
    avatar: 'https://topratedhomepros.com/website/sites-images/testimony-150x150-google.png',
    text: 'Very responsive and reliable. The communication via text was key. The service provided was excellent! Would recommend One Call Handyman Service to anyone in Houston looking for quality home repair work.',
  },
  {
    id: 9,
    name: 'Wendy Johnson',
    rating: 5,
    source: 'Google',
    avatar: 'https://topratedhomepros.com/website/sites-images/testimony-150x150-google.png',
    text: 'Absolutely amazing!!! Service excellent. Work done fast! I will be keeping them on speed dial. Thanks, jobs well done. Highly recommend to all Houston homeowners needing reliable handyman work.',
  },
  {
    id: 10,
    name: 'Grace Farago',
    rating: 5,
    source: 'Google',
    avatar: 'https://topratedhomepros.com/website/sites-images/testimony-150x150-google.png',
    text: 'Excellent, reliable and well priced work. Involved with many diverse projects for over a year. Consistently professional results and outstanding communication every single time.',
  },
];
